import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { deleteElementEndpoint } from 'services/checklistEndPoints';
import { IChecklistDetails } from 'interfaces/checklist.interface';

export const deleteElement = createAsyncThunk('deleteElement', async (id: string) => {
  try {
    const endpoint = deleteElementEndpoint(id);
    return await apiFetch<Partial<IChecklistDetails>>(endpoint).then((res) => res?.data || null);
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    throw Error(message);
  }
});
